import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'

const navItems = [
  { href: '/admin', label: 'Vue d\'ensemble', icon: '📊' },
  { href: '/admin/base-de-donnees', label: 'Base de données', icon: '🗄️' },
  { href: '/admin/utilisateurs', label: 'Utilisateurs', icon: '👥' },
  { href: '/admin/missions', label: 'Missions', icon: '📋' },
  { href: '/admin/types-missions', label: 'Domaines & spécialités', icon: '🏷️' },
  { href: '/admin/stats', label: 'Statistiques', icon: '📈' },
  { href: '/admin/logs', label: 'Logs d\'activité', icon: '🗒️' },
  { href: '/admin/parametres', label: 'Paramètres', icon: '⚙️' },
  { href: '/admin/guide', label: 'Guide admin', icon: '📖' },
]

export default function AdminLayout() {
  const pathname = useLocation().pathname
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 glass-card-dark border-r border-white/[0.08] p-6 flex flex-col gap-2 fixed top-0 left-0 h-screen overflow-y-auto">
        <Link
          to="/"
          className="flex items-center gap-2 mb-6 px-3 py-2.5 rounded-xl bg-accent/15 border border-accent/30 hover:bg-accent/25 transition-all text-accent font-semibold group"
        >
          <span className="text-sm group-hover:-translate-x-0.5 transition-transform">←</span>
          <span className="text-sm">Retour au site</span>
        </Link>

        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 rounded-lg bg-danger/20 border border-danger/30 flex items-center justify-center">
            <span className="text-danger font-bold text-sm">A</span>
          </div>
          <span className="font-semibold text-text-primary">Admin Velink</span>
        </div>

        {navItems.map((item) => {
          const active = pathname === item.href
          return (
            <Link
              key={item.href}
              to={item.href}
              className={[
                'flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm transition-all',
                active
                  ? 'bg-accent/15 border border-accent/25 text-accent'
                  : 'text-text-secondary hover:text-text-primary hover:bg-white/[0.06]',
              ].join(' ')}
            >
              <span>{item.icon}</span>
              {item.label}
            </Link>
          )
        })}

        <div className="mt-auto flex flex-col gap-1">
          <button
            onClick={() => { localStorage.removeItem('velink_token'); navigate('/connexion') }}
            className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-text-muted hover:text-danger transition-colors w-full text-left"
          >
            <span>🚪</span>
            Déconnexion
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="ml-64 flex-1 p-8 min-h-screen">
        <div className="max-w-5xl mx-auto w-full">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
